import React from "react";
import { Divider, Typography, Button, Checkbox, Form, Input } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import logo from "../../../images/sleasing-logo-primary 1.svg";

const { Title } = Typography;

const SPremiumLogin = ({ actions }) => {
  const onFinish = (values) => {
    actions.loginSPremiumUser(values);
  };

  return (
    <div className="flex mt-24">
      <div className="bg-login-white w-[450px] h-[500px] m-auto rounded-md shrink-0">
        <img className="mt-16 m-auto" src={logo} />
        <Form
          className="px-11 "
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Title
            className="w-fit font-normal text-light-blue-login border-b-2 border-light-blue-login"
            level={5}
          >
            Login
          </Title>
          <Divider className="mt-0" />
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: "Korisničko ime ne može biti prazno!",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="text-light-blue-login " />}
              className="h-10 text-[16px]"
              placeholder="korisničko ime"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Loznika ne može biti prazna!",
              },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="text-light-blue-login" />}
              className="h-10 text-[16px]"
              placeholder="lozinka"
            />
          </Form.Item>

          <Form.Item name="rememberMe" valuePropName="checked">
            <Checkbox className="text-black">Zapamti me</Checkbox>
          </Form.Item>

          <Form.Item>
            <Button
              className="bg-light-blue-login w-fit text-white text-[16px] font-bold h-10"
              htmlType="submit"
            >
              PRIJAVI SE
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default SPremiumLogin;
